import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";

export default function CourseCard({ course }) {
    const navigate = useNavigate();
return (
<Card sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
<CardContent>
<Typography variant="h6" fontWeight={600} gutterBottom>
{course.name}
</Typography>
<Typography color="text.secondary">Course ID</Typography>
<Typography mb={1}>{course.id}</Typography>
<Typography color="text.secondary">Room Number</Typography>
<Typography>{course.students}</Typography>
</CardContent>
<Button variant="contained" sx={{ m: 2 }} onClick={() => navigate(`/teacher/course/${course.id}`)}>
View
</Button>
</Card>
);
}